import { render, staticRenderFns } from "./DrugToolsRequest.vue?vue&type=template&id=20d8f136&scoped=true"
import script from "./DrugToolsRequest.vue?vue&type=script&lang=js"
export * from "./DrugToolsRequest.vue?vue&type=script&lang=js"
import style0 from "./DrugToolsRequest.vue?vue&type=style&index=0&id=20d8f136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8f136",
  null
  
)

export default component.exports